import { ContainerProps } from '../../interfaces/container.interface'
import { ClientTypes } from '../../utilities/constants'
import c from 'classnames'
import styles from './Button.module.scss'

interface Props extends ContainerProps {
    client: ClientTypes
    loading: boolean
}

const ButtonComponent = ({ client, loading,  children }: Props) => {
    return (
        <button
            type='submit'
            className={c(
                styles.button,
                client === 'street' ? styles.street : styles.places,
                'animate__animated animate__flipInX animate__delay-3s'
            )}
        >
            {children}
        </button>
    )
}

export default ButtonComponent
